import React, { useState, useEffect } from 'react'
import styles from '../styles.module.css';
import { Button, Tag, ConfigProvider } from 'antd';


function AdminTransactionView({ record }) {

    const [showAdminDetails, setShowAdminDetails] = useState(false);
    // console.log('transaction data: ',record);

    return (

        <div >
            <div className={styles['admin-transaction-setup']} >

                <Tag style={{left:'145px'}} color='blue'>Admin </Tag>


                {<div onClick={() => { setShowAdminDetails(!showAdminDetails) }} className={styles['booking-canceled-show-more']}>{showAdminDetails ? 'hide' : 'more'}</div>}

            </div>

            {
                showAdminDetails &&
                (

                    <div className={styles['admin-transaction-view']}>
                        <div>Admin Name  : <span>{ record?.adminID ? `${record.adminID.firstName} ${record.adminID.lastName}` : 'Name Not Available'}</span></div>
                        <div>Admin ID  : <span>{record?.adminID?._id || 'ID Not Available'}</span></div>
                        <div>Particular : <span>{record?.particular || 'Particular Not Available'}</span></div>
                    </div>

                )
            }

        </div>




    )
}


export default AdminTransactionView;